import React from "react";
import { useSelector } from "react-redux";
import { Translate,I18n } from "react-redux-i18n";
import FormatedPrice from "../../components/FormatedPrice";
import CircleStatus from "../../components/CircleStatus";
import { Card, Icon, Elevation } from "@blueprintjs/core";
import CircleImage from "../Image/CircleImage";
import { isPrylpoolenCircle } from "../../store/my_circles/selectors"

const MyCircleCard = ({ circle, onClick }) => {
  const isPrylpoolen = useSelector(state => isPrylpoolenCircle(state, circle.guid));

  if (!circle.products || circle.products.length === 0) {
    //TODO: delete after tests
    return null;
  }

  const productInfo = isPrylpoolen?circle.address ? circle.address : circle.country:
    `${circle.members.length}/${circle.max_owners_no}, ${I18n.t("circle.in")} ${circle.city}`
    

  return (
    <Card
      interactive={true}
      elevation={Elevation.ONE}
      className="product-card cover-image blocked-card full-width"
      onClick={(_) => onClick(circle.guid)}>
      <div className="product-meta">
        <div className="product-image">
          <CircleImage src={circle.products[0].image_url} size="medium" alt={circle.products[0].name} />
        </div>
      </div>
      <div className="product-side-info">
        <CircleStatus circle={circle} />

        <h1 className="product-name">{circle.products[0].name}</h1>
        <div className="product-split">
          <Icon icon={isPrylpoolen?'map-marker':'people'} iconSize="16" className="icon" />
          <span>
           {productInfo}
          </span>
        </div>
        <div className="card-footer">
          <div className="product-price">
            {!isPrylpoolen &&
              <>
                <strong>
                  <FormatedPrice
                    value={circle.products[0].price / circle.max_owners_no}
                    currency_type={circle.products[0].currency}
                  />
                </strong>
                <small>
                  {isPrylpoolen ? <Translate value="circle.per_month" /> : <Translate value="circle.per_person" />}
                </small>
              </>
            }
          </div>
          <Icon icon="chevron-right" iconSize="20" />
        </div>
      </div>
    </Card>
  );
};

export default MyCircleCard;
